<!--
 * @Author: lijh(¯﹃¯*)
 * @Date: 2024-02-29 15:10:23
 * @LastEditors: lijh(¯﹃¯*)
 * @LastEditTime: 2024-03-06 16:11:33
 * @Description: description
-->
<template>
  <div class="query-form">
    <el-form class="form" :model="params" ref="paramsForm">
      <el-form-item
        class="formItem"
        v-for="item in paramsContent"
        :label="item.label"
        :key="item.value"
        :prop="item.value"
        @keyup.enter.native="handleConfirmClick"
      >
        <el-input
          v-if="item.type === 'input'"
          v-model="params[item.value]"
          style="width:150px"
          placeholder="请输入"
          clearable
          @change="chang(item, $event)"
        />
        <el-input
          v-if="item.type === 'number'"
          v-model.number="params[item.value]"
          style="width:150px"
          placeholder="请输入"
          clearable
          @change="chang(item, $event)"
        />
        <el-select
          v-else-if="item.type === 'select'"
          v-model="params[item.value]"
          style="width:150px"
          placeholder="请选择"
          clearable
          @change="chang(item, $event)"
        >
          <el-option
            v-for="(subItem, index) in item.option"
            :key="index"
            :label="subItem.label"
            :value="subItem.value"
          ></el-option>
        </el-select>
        <el-date-picker
          v-else-if="item.type === 'date' || item.type === 'daterange'"
          v-model="params[item.value]"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="item.picker"
          placeholder="请选择"
          clearable
        >
        </el-date-picker>
        <el-date-picker
          v-else-if="item.type === 'monthrange'"
          v-model="params[item.value]"
          type="monthrange"
          range-separator="至"
          start-placeholder="开始月份"
          end-placeholder="结束月份"
          :picker-options="item.picker"
          placeholder="请选择"
          clearable
        >
        </el-date-picker>
        <yl-cascader
          v-else-if="item.type === 'cascader'"
          v-model="params[item.value]"
          :options="item.option"
          :show-all-levels="false"
          placeholder="请选择"
          style="width: 100%"
          filterable
          clearable
          @change="cascaderChange"
        >
        </yl-cascader>
      </el-form-item>
    </el-form>

    <div class="btns">
      <el-button
        style="margin-top: 20px"
        type="primary"
        @click="handleConfirmClick"
      >
        查询
      </el-button>
    </div>
  </div>
</template>

<script>
import cookie from "@/utils/cookie";
export default {
  name: "NewDataForm",
  components: {},
  props: {
    params: {
      type: Object,
      default: () => {}
    },
    paramsContent: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    handleConfirmClick() {
      this.$emit("handleAcceptParams");
    },
    chang(item, val) {
      if (!val) {
        delete this.params[item.value];
      }
    },
    cascaderChange(value) {
      this.$emit("cascaderChange", value);
    }
  }
};
</script>
<style lang="scss" scoped>
.query-form {
  display: flex;
  align-items: center;
  .form {
    max-width: 92%;
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    .formItem {
      margin-right: 20px;
      margin-bottom: 15px;
    }
  }
  .btns {
    margin-left: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/MemberQueryForm.vue